module.exports = __webpack_public_path__ + "img/meetsanta4.2656a57f.jpg";